/*
 * ---------------------------------------------------------------------------
 *
 * COPYRIGHT (c) 2017 KRONOS Inc. All Rights Reserved.
 *
 * The copyright to the computer program(s) herein is the property of
 * AD OPT Technologies Inc. The program(s) may be used and/or copied
 * only with the written permission from AD OPT Technologies Inc.
 * or in accordance with the terms and conditions stipulated in the
 * agreement/contract under which the program(s) have been supplied.
 *
 * Date  : 2017-08-17
 *
 * ---------------------------------------------------------------------------
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DefaultSelectField } from '../../../components/SelectFields'
import { DefaultInputLabel } from '../../../components/InputLabels'
import { MenuItem } from '@material-ui/core';
import { common, COMPONENTS } from './../index.js';
import './styles.scss';


class MULTISELECT extends Component {

  constructor(props) {
    super(props);
    this.MULTISELECT_SEPARATOR = ',';
    this.state = {
      values: this.getDefaultValues() || []
    };
  }

  getDefaultValues = () => {
    const value = this.getParameter().value;
    const defaultValue = this.getParameter().defaultValue;

    return value ? value.split(this.MULTISELECT_SEPARATOR) : defaultValue;
  };

  getParameter = () => this.props.parameter;

  getDescription = () => {
    const description = this.getParameter().description;
    return description || ' ';
  };

  getDataId = () => {
    const sequence = this.getParameter().sequence;
    const sequenceId = sequence || COMPONENTS.WISH_SEQUENCE;
    return `drop-down-${sequenceId}`;
  };

  getAllowedValuesAndKeys = () => {
    const currentParameter = this.getParameter();
    const allowedValues = currentParameter.allowedValues ? currentParameter.allowedValues : {};
    const allowedValuesKeys = Object.keys(allowedValues);
    return { allowedValues, allowedValuesKeys };
  };

  buildSelectOptions = () => {
    const { values } = this.state;
    const { allowedValues, allowedValuesKeys } = this.getAllowedValuesAndKeys();
    const options = allowedValuesKeys.map(
      value => (
        <MenuItem
          className="multiselect-item"
          key={value}
          insetChildren
          checked={this.isChecked(values, value)}
          value={value}
          data-id={this.getDataId()}
        >{this.formatPrimaryText(allowedValues, value)}</MenuItem>
      )
    );
    return options;
  };

  isChecked = (values, value) => values && values.indexOf(value) > -1;

  formatPrimaryText = (values, value) => {
    const description = values[value];
    return description !== value ? `${value} - ${description}` : value;
  };

  handleChange = (event, index, values) => {
    const { setSelectedParameterValues, parameter } = this.props;
    this.setState(state => ({ ...state, values: event.target.value }));
    this.props.handleFormChange(event, index, this.state.values.sort(), undefined, undefined, this.getParameter().parameterId);
    setSelectedParameterValues(
        parameter.sequence - 1,
        event.target.value.length > 0 ? event.target.value.join(',') : undefined,
        parameter.parameterId
    );
  };

  render() {
    const { values } = this.state;
    const description = this.getDescription();
    const options = this.buildSelectOptions();

    return (
      <div className="form-item-container">
        <DefaultInputLabel>{description}</DefaultInputLabel>
        <DefaultSelectField
          menuStyle={{ zIndex: 2105 }}
          style={{ zIndex: 2105 }}
          multiple
          value={values}
          onChange={this.handleChange}
          floatingLabelFixed
          selectedMenuItemStyle={{ color: common.colors.CI_RED }}
          maxHeight={302}
        >
          {options}
        </DefaultSelectField>
      </div>
    );
  }
}

MULTISELECT.propTypes = {
  parameter: PropTypes.object,
  handleFormChange: PropTypes.func,
  setSelectedParameterValues: PropTypes.func,
};

MULTISELECT.defaultProps = {
  parameter: {},
  handleFormChange: () => {},
  setSelectedParameterValues: () => {},
};

export default MULTISELECT;
